// Mock data for Inmigración Hispana Multi Services

export const companyInfo = {
  name: "Inmigración Hispana Multi Services",
  logo: "https://customer-assets.emergentagent.com/job_1d7b4382-1dd8-4505-b5b0-2bf9cb18b420/artifacts/x4n5gd2x_38a1797c-bc2c-4cf6-be15-8e523da1619c.png",
  wilsonPhoto: "https://customer-assets.emergentagent.com/job_1d7b4382-1dd8-4505-b5b0-2bf9cb18b420/artifacts/fw86bbqg_81289a24-612d-47a6-9c39-5d12af26e18f.png",
  phone1: "475-204-8396",
  phone2: "475-204-1863",
  address: "240 Main Street",
  telLink1: "tel:4752048396",
  telLink2: "tel:4752041863"
};

export const services = [
  {
    id: "notaria",
    icon: "FileText",
    title: "Notaría Pública",
    description: "Servicios de notaría pública y asistencia con documentos y trámites notariales."
  },
  {
    id: "migratorios",
    icon: "Globe",
    title: "Trámites Migratorios",
    description: "Estamos aquí para ayudarte con cualquier trámite migratorio de forma clara y responsable."
  },
  {
    id: "asilos",
    icon: "Shield",
    title: "Asilos y Permisos de Trabajo",
    description: "Aplicamos para tu asilo, permiso de trabajo y Social Security según tu situación."
  },
  {
    id: "poderes",
    icon: "Scale",
    title: "Poderes y Trámites en Ecuador",
    description: "Gestión de poderes, certificados, apostillas y trámites judiciales en Ecuador."
  },
  {
    id: "licencias",
    icon: "Car",
    title: "Licencias, Vehículos y Seguros",
    description: "Hacemos tu trámite en un solo día: placas y registros vehiculares, tengas o no licencia o solo permiso de trabajo."
  },
  {
    id: "impuestos",
    icon: "Calculator",
    title: "Impuestos y Tax ID (ITIN)",
    description: "Facilitamos tu declaración de impuestos y realizamos Tax ID de forma legal y segura."
  },
  {
    id: "empresas",
    icon: "Building",
    title: "Creación de Empresas",
    description: "Hacemos tu empresa legal y con éxito, desde el inicio hasta su registro."
  }
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_1d7b4382-1dd8-4505-b5b0-2bf9cb18b420/artifacts/hwj3hyo7_WhatsApp%20Image%202026-01-15%20at%201.36.29%20PM.jpeg",
    alt: "Cliente satisfecho con su trámite"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_1d7b4382-1dd8-4505-b5b0-2bf9cb18b420/artifacts/rurnt128_WhatsApp%20Image%202026-01-15%20at%201.36.45%20PM.jpeg",
    alt: "Atención personalizada en oficina"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_1d7b4382-1dd8-4505-b5b0-2bf9cb18b420/artifacts/c4s89mo3_WhatsApp%20Image%202026-01-15%20at%201.55.51%20PM.jpeg",
    alt: "Oficina profesional"
  }
];

export const legalTransparency = {
  title: "Transparencia Legal",
  text: "Wilson Cruz es abogado ecuatoriano, licenciado en Ecuador y residente en Estados Unidos. Brinda asesoría legal exclusivamente relacionada con legislación ecuatoriana. No ejerce como abogado en los Estados Unidos."
};
